import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faRightFromBracket,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import {
  ButtonComponent,
  ContentComponent,
  SingleCardLayoutComponent,
} from '@lyceo/shared/ui';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { LogoComponent } from '@lyceo/homi/shared/ui';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'homi-no-access-page',
  imports: [
    SingleCardLayoutComponent,
    FaIconComponent,
    ContentComponent,
    ButtonComponent,
    LogoComponent,
    TranslocoDirective,
  ],
  templateUrl: './no-access-page.component.html',
  styleUrl: './no-access-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAccessPageComponent {
  private readonly authFacade: AuthFacade = inject(AuthFacade);

  protected readonly faRightFromBracket: IconDefinition = faRightFromBracket;

  public logout(): void {
    this.authFacade.userLogout();
  }
}
